import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CaseViewRoutingService } from '../../services/case-view-routing.service';
import { InsuranceCase } from '../../../app-create-case/models/insurance-case.model';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-app-basic-list',
    templateUrl: './app-basic-list.component.html',
    styleUrls: ['./app-basic-list.component.scss'],
    standalone: false
})
export class AppBasicListComponent implements OnInit {
    //Input section
    @Input() bgColor = '#DADADA';
    @Input() fgColor = '#FFFFFF';
    @Input() data = [];
    @Input() titleDisplay = {};
    @Input() subTitleDisplay = {};
    @Input() rootRoute: string;
    @Input() header: string;
    @Input() truncate: number;
    @Input() isRadioButtonAvailable: boolean = false;
    @Input() duplicationCaseReturnSample = {};
    @Input() insuranceCompanyId = '';
    @Output() outputForDuplicateCaseOrEmail = new EventEmitter<any>();
    @Input() unSelectedItem: boolean = false;
    @Input() source: string = '';
    
    @Input() isHeaderNeedToShow: boolean = true;

    @Input() set selectedItemIds(value) {
        if (value && value.length > 0) {
            this.selectedConnectedCaseIds = value;
            if (this.source === 'create-case') {
                this.setOutputData();
            }
        }
    }

    unSelectedIds: string[] = [];
    toolTipDisplay: any = {};
    selectedConnectedCaseIds: string[] = [];

    constructor(
        private readonly router: Router,
        public readonly translateService: TranslateService,
        private caseViewRoutingService: CaseViewRoutingService
    ) {}

    ngOnInit() {
        this.toolTipDisplay = {
            ...this.titleDisplay,
            ...this.subTitleDisplay
        };
        this.data = _.uniqBy(this.data, 'ItemId');
        if (this.source === 'create-case') {
            this.setOutputData();
        }
    }

    private setOutputData(): void {
        if (this.selectedConnectedCaseIds?.length > 0 && !this.unSelectedItem) {
            this.outputForDuplicateCaseOrEmail.emit(this.selectedConnectedCaseIds);
        }
    }

    public clickItem(itemId: string): void {
        if (this.rootRoute === 'cases') {
            const route = this.caseViewRoutingService.getDetailsRoute(itemId);
            window.open(
                this.router.serializeUrl(this.router.createUrlTree(route)),
                '_blank'
            );
        } else {
            window.open(
                this.router.serializeUrl(
                    this.router.createUrlTree([this.rootRoute, this.insuranceCompanyId, 'mail', itemId], {
                        queryParams: { isConnectMail: true }
                    })
                ),
                '_blank'
            );
        }
    }

    public changeOption(event: any, item: InsuranceCase): void {
        const isChecked = event.checked.includes(item.ItemId);

        if (this.unSelectedItem) {
            if (isChecked) {
                this.unSelectedIds = this.unSelectedIds.filter(x => x !== item.ItemId);
            } else {
                this.unSelectedIds.push(item.ItemId);
            }
            this.outputForDuplicateCaseOrEmail.emit(this.unSelectedIds);
        } else {
            this.outputForDuplicateCaseOrEmail.emit(this.selectedConnectedCaseIds);
        }
    }
}
